import { render, staticRenderFns } from "./LdpBaiViet.vue?vue&type=template&id=06fac8e3&scoped=true&"
import script from "./LdpBaiViet.vue?vue&type=script&lang=js&"
export * from "./LdpBaiViet.vue?vue&type=script&lang=js&"
import style0 from "./LdpBaiViet.vue?vue&type=style&index=0&id=06fac8e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fac8e3",
  null
  
)

export default component.exports